const styles = {
  root: {
    backgroundColor: "#ECEAE5",
    minHeight: "100vh",
    p: 3,
  },
  header: {
    textAlign: "center",
    fontWeight: 600,
    fontSize: 28,
  },
  subtitle: {
    textAlign: "center",
    fontSize: 16,
    opacity: 0.6,
  },
  formContainer: {
    backgroundColor: "white",
    borderRadius: 4,
    p: 3,
    mt: 3,
  },
  chip: {
    border: "1px black solid",
    width: "max-content",
    fontFamily: "Inter Tight, sans-serif",
    fontWeight: 600,
    fontSize: 16,
    borderRadius: 4,
    px: 2,
    py: 1,
    mb: 2,
  },
  nextPage: {
    mt: 3,
    textTransform: "none",
    borderRadius: 8,
    px: 3,
    py: 1.5,
    fontSize: 18,
  },
  backButton: {
    mt: 2,
    textTransform: "none",
  },
};

export default styles;
